export default class FontOffsetParams {

    constructor(xOffset = 0, xMultiplier = 0, yOffset = 0, yMultiplier = 0) {
        this.xOffset = xOffset;
        this.xMultiplier = xMultiplier;
        this.yOffset = yOffset;
        this.yMultiplier = yMultiplier;
    }

};
